<div class="row">
  <div class="col-12 col-md-4 mb-5">
    <div class="row" [formGroup]="form">
      <div class="col-12 mb-3">
        <lib-gung-text-input-typeahead
          #gungTextInputTypeahead
          [class.d-none]="!cachedServicesWorkingOrder"
          formControlName="article"
          gungTranslate="SEARCH_SERVICE"
          [list]="articles"
          (selectItem)="selectArticle($event)"
          [search]="itemIdSearchTypeahead"
          [resultFormatter]="resultFormatterItemId"
          [inputFormatter]="resultFormatterItemId"
        ></lib-gung-text-input-typeahead>
        <ng-container *ngTemplateOutlet="!cachedServicesWorkingOrder ? isLoading : undefined; context: { $implicit: undefined}"></ng-container>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-number-input
          gungTranslate="SERVICE_QUANTITY"
          formControlName="qty"
          [placeholder]="''"
        ></lib-gung-number-input>
        <lib-forms-message-error [controller]="form.get('qty')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <button class="btn btn-primary w-100" (click)="addToWorkingOrder($event)" [disabled]="form.invalid" translate>ADD_TO_WORKING_ORDER</button>
      </div>

      <div class="col-12">
        <div *ngIf="noServicesSelected" class="alert alert-danger" translate>NO_SERVICES_SELECTED_ERROR</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-8 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>SERVICE_ID</th>
          <th translate>SERVICE_NAME</th>
          <th translate>QUANTITY</th>
          <th translate>UNIT_PRICE</th>
          <th translate>TOTAL_PRICE</th>
          <th translate></th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.services; let index = index">
          <td [attr.data-label]="'SERVICE_ID' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'SERVICE_NAME' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.name }}</a>
          </td>
          <td [attr.data-label]="'QUANTITY' | translate">
            {{ row.qty }}
          </td>
          <td [attr.data-label]="'UNIT_PRICE' | translate">
            <span *ngIf="row.price.discount && row.price.valueNoDiscount">
              <span class="linethrough">{{ row.price.valueNoDiscount | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2' }}</span>
              <span class="ml-2">(-{{ row.price.discount }}%)</span>
            </span>
            {{ row.price.value | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2' }}          </td>
          <td [attr.data-label]="'TOTAL_PRICE' | translate">
            {{ row.price.value * row.qty | gungCurrency: row.price.currency:'symbol-narrow':'1.2-2' }}
          </td>
          <td [attr.data-label]="'' | translate">
            <div class="d-flex flex-row w-100 justify-content-end">
              <button class="btn btn-sm btn-outline-secondary delete-button mr-1" (click)="removeFromWorkingOrder(index)">
                <i class="fal fa-minus-circle"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="calculatedTotals">
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"><b translate>TOTAL_QUANTITY</b></td>
          <td [attr.data-label]="'TOTAL_QUANTITY' | translate">{{ calculatedTotals.qty }}</td>
          <td class="hide-mobile-table"><b translate>TOTAL_VALUE</b></td>
          <td [attr.data-label]="'TOTAL_VALUE' | translate">{{ calculatedTotals.total | gungCurrency: calculatedTotals.currency:'symbol-narrow':'1.2-2' }}</td>
          <td class="hide-mobile-table"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="alert alert-info mt-4">
      <p translate>WORKING_ORDER_STEP_INFO_3</p>
    </div>
  </div>
</div>

<ng-template #isLoading>
  <i class="fa fa-spinner fa-spin fa-2x"></i>
</ng-template>
